import { z } from 'zod'
import { regexPatterns } from '@/utils/constants/regex'

const letterDigitSeparatedMessage =
  'حروف و اعداد نباید به هم چسبیده باشند؛ بین آن‌ها فاصله بگذارید'

export const baseAddressSchema = {
  provinces: z.number({ message: 'لطفا استان خود را وارد کنید' }),
  cities: z.number({ message: 'لطفا شهر خود را وارد کنید' }),
  address: z
    .string({ required_error: 'لطفا آدرس خود را وارد کنید' })
    .trim()
    .refine((val) => !regexPatterns.letterAdjacentToDigit.test(val), {
      message: letterDigitSeparatedMessage
    }),
  detail: z
    .string({ required_error: 'لطفا جزئیات خود را وارد کنید' })
    .trim()
    .refine((val) => !regexPatterns.letterAdjacentToDigit.test(val), {
      message: letterDigitSeparatedMessage
    }),
  postalCode: z
    .string({ required_error: 'لطفا کدپستی خود را وارد کنید' })
    .regex(/^\d+$/, 'کدپستی فقط می‌تواند شامل اعداد باشد')
    .min(10, 'کدپستی باید ۱۰ رقم باشد')
    .max(10, 'کدپستی باید ۱۰ رقم باشد'),
  is_warehouse: z.boolean()
}

export const warehouseAddressSchema = {
  warehouseProvinces: z.number({ message: 'لطفا استان انبار را وارد کنید' }),
  warehouseCities: z.number({ message: 'لطفا شهر انبار را وارد کنید' }),
  warehouseAddress: z
    .string({ required_error: 'لطفا آدرس انبار را وارد کنید' })
    .trim()
    .refine((val) => !regexPatterns.letterAdjacentToDigit.test(val), {
      message: letterDigitSeparatedMessage
    }),
  warehouseDetail: z
    .string({ required_error: 'لطفا جزئیات انبار را وارد کنید' })
    .trim()
    .refine((val) => !regexPatterns.letterAdjacentToDigit.test(val), {
      message: letterDigitSeparatedMessage
    }),
  warehousePostalCode: z
    .string({ required_error: 'لطفا کدپستی انبار را وارد کنید' })
    .regex(/^\d+$/, 'کدپستی فقط شامل اعداد باشد')
    .min(10, 'کدپستی باید ۱۰ رقم باشد')
    .max(10, 'کدپستی باید ۱۰ رقم باشد'),
  warehouseLat: z.number(),
  warehouseLng: z.number()
}

export const getAddressFormSchema = (includeWarehouse: boolean) =>
  z.object({
    ...baseAddressSchema,
    ...(includeWarehouse ? warehouseAddressSchema : {})
  })
